import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';  // Import PrimeNG Calendar Module
import { TableModule } from 'primeng/table';
import { DrawerModule } from 'primeng/drawer';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { OrderListModule } from 'primeng/orderlist';
import { CheckboxModule } from 'primeng/checkbox';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TooltipModule } from 'primeng/tooltip';
import { ChipModule } from 'primeng/chip';
import { PopoverModule } from 'primeng/popover';
import { ReportDetailsRoutingModule } from './report-details-routing.module';
import { ReportDetailsComponent } from './report-details.component';
import { SharedModule } from '../../shared/shared.module';
import { TimezoneTransformPipe } from '../../shared/pipes/timezone-transform.pipe';

//for graphs
import { LineGraphComponent } from './graphs/line-graph/line-graph.component';
import { StackedColumnGraphComponent } from './graphs/stacked-column-graph/stacked-column-graph.component';
import { StackedAreaGraphComponent } from './graphs/stacked-area-graph/stacked-area-graph.component';
import { RangeAreaGraphComponent } from './graphs/range-area-graph/range-area-graph.component';
import { NestedDonutGraphComponent } from './graphs/nested-donut-graph/nested-donut-graph.component';
import { ClusteredColumnGraphComponent } from './graphs/clustered-column-graph/clustered-column-graph.component';
import { PieGraphComponent } from './graphs/pie-graph/pie-graph.component';
import { SemiCirclePieGraphComponent } from './graphs/semi-circle-pie-graph/semi-circle-pie-graph.component';
import { DonutGraphComponent } from './graphs/donut-graph/donut-graph.component';
import { PyramidGraphComponent } from './graphs/pyramid-graph/pyramid-graph.component';
import { BarGraphComponent } from './graphs/bar-graph/bar-graph.component';
import { ColumnGraphComponent } from './graphs/column-graph/column-graph.component';
import { CurvedColumnGraphComponent } from './graphs/curved-column-graph/curved-column-graph.component';
import { SmoothedLineGraphComponent } from './graphs/smoothed-line-graph/smoothed-line-graph.component';
import { StepLineGraphComponent } from './graphs/step-line-graph/step-line-graph.component';
import { ThreeDPieGraphComponent } from './graphs/three-d-pie-graph/three-d-pie-graph.component';
import { ThreeDBarGraphComponent } from './graphs/three-d-bar-graph/three-d-bar-graph.component';
import { ThreeDColumnGraphComponent } from './graphs/three-d-column-graph/three-d-column-graph.component';
import { ThreeDCylinderGraphComponent } from './graphs/three-d-cylinder-graph/three-d-cylinder-graph.component';
import { FunnelGraphComponent } from './graphs/funnel-graph/funnel-graph.component';
import { LollipopGraphComponent } from './graphs/lollipop-graph/lollipop-graph.component';
import { DraggablePieGraphComponent } from './graphs/draggable-pie-graph/draggable-pie-graph.component';
import { SpiralTimelineGraphComponent } from './graphs/spiral-timeline-graph/spiral-timeline-graph.component';
import { FishboneTimelineGraphComponent } from './graphs/fishbone-timeline-graph/fishbone-timeline-graph.component';
import { SerpentineTimelineGraphComponent } from './graphs/serpentine-timeline-graph/serpentine-timeline-graph.component';
import { RoadTimelineGraphComponent } from './graphs/road-timeline-graph/road-timeline-graph.component';
import { LinearTimelineGraphComponent } from './graphs/linear-timeline-graph/linear-timeline-graph.component';
import { SpiralBarTimelineGraphComponent } from './graphs/spiral-bar-timeline-graph/spiral-bar-timeline-graph.component';
import { HierarchyReportComponent } from './components/hierarchy-report/hierarchy-report.component';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    ReportDetailsComponent,
    LineGraphComponent,
    StackedColumnGraphComponent,
    StackedAreaGraphComponent,
    RangeAreaGraphComponent,
    NestedDonutGraphComponent,
    ClusteredColumnGraphComponent,
    PieGraphComponent,
    SemiCirclePieGraphComponent,
    DonutGraphComponent,
    PyramidGraphComponent,
    BarGraphComponent,
    ColumnGraphComponent,
    CurvedColumnGraphComponent,
    SmoothedLineGraphComponent,
    StepLineGraphComponent,
    ThreeDPieGraphComponent,
    ThreeDBarGraphComponent,
    ThreeDColumnGraphComponent,
    ThreeDCylinderGraphComponent,
    FunnelGraphComponent,
    LollipopGraphComponent,
    DraggablePieGraphComponent,
    SpiralTimelineGraphComponent,
    FishboneTimelineGraphComponent,
    SerpentineTimelineGraphComponent,
    RoadTimelineGraphComponent,
    LinearTimelineGraphComponent,
    SpiralBarTimelineGraphComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ButtonModule,
    DatePickerModule,
    FormsModule,
    CalendarModule,
    TableModule,
    DrawerModule,
    DialogModule,
    SelectModule,
    OrderListModule,
    CheckboxModule,
    ToggleSwitchModule,
    InputTextModule,
    RadioButtonModule,
    MultiSelectModule,
    IconFieldModule,
    InputIconModule,
    TooltipModule,
    ChipModule,
    PopoverModule,
    ReportDetailsRoutingModule,
    HierarchyReportComponent
  ],
  providers: [
    DatePipe,
    TimezoneTransformPipe
  ]
})
export class ReportDetailsModule { }
